module.exports = "<div class=\"footer\">\r\n  <span class=\"footer-text\">&copy; {{copyrightName}} - {{year}}</span>\r\n</div>"